import { getUserAccessibleModulesApi } from '@/services/module';
import { getUserApi, putUserApi } from '@/services/user';
import { getLandingPage } from '@/utils/getSsoUrl';
import { getStorageCompanyId, setupCompanyId } from '@/utils/localStorage';
import { history, useModel } from 'umi';

export default () => {
  const { initialState, setInitialState } = useModel('@@initialState');

  const fetchUser = async () => {
    return getUserApi()
      .then(async (user) => {
        if (user) {
          setInitialState({
            ...initialState,
            currentUser: user,
          });
        }
        return user;
      })
      .catch((err) => console.log(err));
  };

  const updateUser = async (params: API.PutUserPersonalParams | API.PutUserPasswordParams) =>
    putUserApi(params).then(async (user) => {
      if (user) {
        setInitialState({
          ...initialState,
          currentUser: user,
        });
      }
    });

  const loginOnSuccess = () => {
    fetchUser().then(async (res) => {
      setupCompanyId(res as API.User);
      const selectCompanyId = getStorageCompanyId() || res?.companies[0]?.id;
      let accessibleModules: API.CompanyModuleSubscription[] = [];
      if (selectCompanyId && selectCompanyId !== 'undefined') {
        try {
          accessibleModules = await getUserAccessibleModulesApi(selectCompanyId);
        } catch {
          accessibleModules = [];
        }
      }
      setInitialState((s) => ({
        ...s,
        currentUser: res as API.User,
        accessibleModules,
      }));

      const { useAia, useGenie } =
        res?.companies.find((company) => company?.id === selectCompanyId) || {};
      history.push(getLandingPage({ useAia, useGenie }));
    });
  };

  return {
    fetchUser,
    loginOnSuccess,
    updateUser,
  };
};
